import * as Api from '@Api/index';

interface Params {
  name: any;
  body: any;
}

async function sendFabrics({ name, body }: Params) {
  const url = `/marketing/voting/v1/${name}  `;
  const res = await Api.query<any>({
    path: url,
    opts: {
      method: 'POST',
      body,
    },
  });

  return res;
}

export default sendFabrics;
